import { Component } from ".././base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class RelatedContent extends Component {

    private static tMode = "collection";
    private static healioUrl = "https://www.healio.com";
    private hwsHost: string | undefined;
    private cleanArticleId: string | undefined;
    private primarySpecialtyName: string | undefined;
    private primarySubSpecialtyId: string | undefined;
    public relOnePopulated = false;
    public relTwoPopulated = false;
    public relThreePopulated = false;
    public relLoaded = false;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.hwsHost = this._element.dataset.hwsHost;
        this.cleanArticleId = this._element.dataset.cleanItemId;
        this.primarySpecialtyName = this._element.dataset.primarySpecialtyName;
        this.primarySubSpecialtyId = this._element.dataset.primarySubSpecId;

        if (!this.primarySpecialtyName || this.primarySpecialtyName === "") { this.primarySpecialtyName = "na"; }

        if (!this.primarySubSpecialtyId || this.primarySubSpecialtyId === "") { this.primarySubSpecialtyId = "na"; }
    }

    public async init(): Promise<void> {
        if (window.Visitor !== undefined && window.Visitor !== "") {
            this.botCheck();
        } else {
            $(window).on("globalsloaded", () => this.botCheck());
        }

    }

    public async botCheck(): Promise<void> {
        if (window.Visitor.isbot || window.Visitor.type === "DC") {
            return;
        }
        await this.getRelatedContent();
    }

    public async getRelatedContent(): Promise<void> {
        //check if already populated
        if (this.relLoaded) {
            return;
        }
        this.relLoaded = true;
        const relatedContent = this;
        $(window).on('load', function () {

            $.ajax({
                type: "GET",
                url: relatedContent.hwsHost + "/~/hws/relatedchips/" + relatedContent.cleanArticleId + "/" + RelatedContent.tMode + "/" + relatedContent.primarySpecialtyName + "/" + relatedContent.primarySubSpecialtyId,
                success: function (msg) {
                    var readNextOne = msg.response.relatedItems[0];
                    var readNextTwo = msg.response.relatedItems[1];
                    var readNextThree = msg.response.relatedItems[2];

                    if (readNextOne) {
                        $(".related__container").removeClass("d-none");
                        relatedContent.relOnePopulated = relatedContent.populateReadNext($("#readOne"), readNextOne);;
                    } else {
                        $("#readOne").addClass("d-none");
                    }

                    if (readNextTwo) {
                        relatedContent.relTwoPopulated = relatedContent.populateReadNext($("#readTwo"), readNextTwo);;
                    } else {
                        $("#readTwo").addClass("d-none");
                    }

                    if (readNextThree) {
                        relatedContent.relTwoPopulated = relatedContent.populateReadNext($("#readThree"), readNextThree);;
                    } else {
                        $("#readThree").addClass("d-none");
                    }

                    $("#related-content-template").remove();
                },
                error: function () {
                    $("#readOne").addClass("d-none");
                    $("#readTwo").addClass("d-none");
                    $("#readThree").addClass("d-none");
                    console.log("Error loading Related Content.");
                },
                timeout: 10000
            });
        });

    }

    private populateReadNext(element: any, rec: any): boolean {
        var relatedContentHtml = $("#related-content-template").html();
        $(element).html(relatedContentHtml);

        //isolate the media body a tag
        var recType = rec.type;
        var sponsoredContent = false;
        if (recType !== undefined && recType === 'HSS') {
            sponsoredContent = true;
        }

        var mediabody = $(element.find(".media-body"));
        $(mediabody).find("[data-card-title]").eq(0).html(rec.title);
        $(mediabody).find("[data-card-engagement]").eq(0).html(rec.engagementtype);
        $(mediabody).find("[data-card-link]").eq(0).attr("href", rec.url.toString().replace(RelatedContent.healioUrl, ""));

        //isolate the image a tag using children, only update href
        $(element).children("a").eq(0).attr("href", rec.url.toString().replace(RelatedContent.healioUrl, ""));

        if (rec.thumb !== '' && rec.thumb !== undefined && rec.thumb !== null) {
            var thumbnailid = rec.thumb;
            var mediaidindex = thumbnailid.indexOf("mediaid");
            if (mediaidindex > -1) thumbnailid = thumbnailid.substr(mediaidindex, mediaidindex + 41);
            thumbnailid = thumbnailid.replace('mediaid="{', '').replace('}"', '').replace('"', '').replace(/-/g, '');
            var thumbnailurl = thumbnailid.length > 1 ? '/~/media/' + thumbnailid + '.webp?w=95' : '';
            if (thumbnailurl !== '') {
                $(element).find("img").attr("src", thumbnailurl);
                $(element).find("img").attr("alt", rec.title);
                $(element).find("img").removeClass("d-none");
            }
        }

        var cardBody = $(element.find("[data-card-body]"));
        var sponsorblock = $(element.find(".sponsor"));

        if (rec.collectionarticleid !== '' && rec.collectionarticleid !== undefined && rec.collectionarticleid !== null) {
            sponsorblock.remove();
            $(cardBody).html(rec.collectionarticletitle);
        }

        if (sponsoredContent) {
            if (rec.description && rec.description !== null) {
                cardBody.html(rec.description)
            }
        } else {
            sponsorblock.remove();
        }
        return true;
    }

}

ComponentFactory.registerComponent("RelatedContent", RelatedContent);
